import {
	TEAMS_SUCCESS,
	TEAMS_FAILURE,
	TEAMS_LOADING,
	POST_LOADING,
	POST_SUCCESS,
	POST_FAILURE,
	POSTS_LOADING,
	POSTS_SUCCESS,
	POSTS_FAILURE,
	PAGINATED_POSTS_LOADING,
	PAGINATED_POSTS_SUCCESS,
	PAGINATED_POSTS_FAILURE,
	SUBPOSTS_LOADING,
	SUBPOSTS_SUCCESS,
	SUBPOSTS_FAILURE,
	CREATE_TEAM,
	CREATE_TEAM_SUCCESS,
	CREATE_TEAM_FAILURE,
	SENDING_TOKENS,
	SEND_TOKENS_SUCCESS,
	SEND_TOKENS_FAILURE,
	SENDING_SUBPOST_TOKENS,
	SEND_SUBPOST_TOKENS_SUCCESS,
	SEND_SUBPOST_TOKENS_FAILURE,
	RESET_SEND_TOKENS_SUCCESS,
	LIKE_POST,
	LIKE_POST_SUCCESS,
	LIKE_POST_FAILURE,
	LIKE_SUBPOST,
	LIKE_SUBPOST_SUCCESS,
	LIKE_SUBPOST_FAILURE,
	ADD_TEAM_MEMBERS,
	ADD_TEAM_MEMBERS_SUCCESS,
	ADD_TEAM_MEMBERS_FAILURE,
	RESET_ADD_TEAM_MEMBERS_COMPLETE,
	EDIT_TEAM,
	EDIT_TEAM_SUCCESS,
	EDIT_TEAM_FAILURE,
	DELETE_TEAM,
	DELETE_TEAM_SUCCESS,
	DELETE_TEAM_FAILURE,
	RESET_DELETE_TEAM_SUCCESS,
	RESET_EDIT_TEAM_SUCCESS,
	RESET_CREATE_TEAM_SUCCESS,
	START_SEASON,
	START_SEASON_SUCCESS,
	START_SEASON_FAILURE,
	RESET_START_SEASON_SUCCESS,
	END_SEASON,
	END_SEASON_SUCCESS,
	END_SEASON_FAILURE,
	RESET_END_SEASON_SUCCESS,
	UPDATE_SEASON,
	UPDATE_SEASON_SUCCESS,
	UPDATE_SEASON_FAILURE,
	RESET_UPDATE_SEASON_SUCCESS,
	DELETING_POST,
	DELETE_POST_FAILURE,
	DELETE_POST_SUCCESS,
	RESET_DELETE_POST_SUCCESS,
	TEAM_USER_STATS_LOADING,
	TEAM_USER_STATS_SUCCESS,
	TEAM_USER_STATS_FAILURE,
	SENDING_SHOUT_OUT_SUCCESS,
	SENDING_SHOUT_OUT_FAILURE,
	SENDING_SHOUT_OUT,
	RESET_SENDING_SHOUT_OUT_SUCCESS,
	DELETING_SUBPOST,
	DELETE_SUBPOST_FAILURE,
	DELETE_SUBPOST_SUCCESS,
	RESET_DELETE_SUBPOST_SUCCESS,
} from 'redux/reduxConstants';
import { Post } from '../models/post';
import { Subpost } from 'redux/models/subpost';
import { UserTeams } from 'redux/models/userTeams';
import { EditSeason } from 'redux/models/editSeason';
import { TeamStats } from 'redux/models/stat';

export function teamsLoading() {
	return { type: TEAMS_LOADING };
}

export function teamsSuccess(teams: string[]) {
	return { type: TEAMS_SUCCESS, teams };
}

export function teamsFailure(error: string) {
	return { type: TEAMS_FAILURE, error };
}

export function postLoading() {
	return { type: POST_LOADING };
}

export function postSuccess(post: Post) {
	return { type: POST_SUCCESS, post };
}

export function postFailure(error: string) {
	return { type: POST_FAILURE, error };
}

export function postsLoading() {
	return { type: POSTS_LOADING };
}

export function postsSuccess(posts: Post[]) {
	return { type: POSTS_SUCCESS, posts };
}

export function postsFailure(error: string) {
	return { type: POSTS_FAILURE, error };
}

export function paginatedPostsLoading(pageSize: number = 25, continuationToken: any = null) {
	return { type: PAGINATED_POSTS_LOADING, pageSize, continuationToken };
}

export function paginatedPostsSuccess(posts: Post[], pageSize: number, continuationToken: any) {
	return { type: PAGINATED_POSTS_SUCCESS, posts, pageSize, continuationToken };
}

export function paginatedPostsFailure(error: string) {
	return { type: PAGINATED_POSTS_FAILURE, error };
}

export function subpostsLoading() {
	return { type: SUBPOSTS_LOADING };
}

export function subpostsSuccess(postId: string, subposts: Subpost[]) {
	return { type: SUBPOSTS_SUCCESS, postId, subposts };
}

export function subpostsFailure(error: string) {
	return { type: SUBPOSTS_FAILURE, error };
}

export function creatingTeam() {
	return { type: CREATE_TEAM };
}

export function createTeamSuccess(userTeams: UserTeams) {
	return { type: CREATE_TEAM_SUCCESS, userTeams };
}

export function createTeamFailure(error: string) {
	return { type: CREATE_TEAM_FAILURE, error };
}

export function sendingTokens() {
	return { type: SENDING_TOKENS };
}

export function sendTokensSuccess(post: Post) {
	return { type: SEND_TOKENS_SUCCESS, post };
}

export function sendTokensFailure(error: string) {
	return { type: SEND_TOKENS_FAILURE, error };
}

export function sendingSubpostTokens() {
	return { type: SENDING_SUBPOST_TOKENS };
}

export function sendSubpostTokensSuccess(subpost: Subpost) {
	return { type: SEND_SUBPOST_TOKENS_SUCCESS, subpost };
}

export function sendSubpostTokensFailure(error: string) {
	return { type: SEND_SUBPOST_TOKENS_FAILURE, error };
}

export function resetSendTokensSuccess() {
	return { type: RESET_SEND_TOKENS_SUCCESS };
}

export function likingPost() {
	return { type: LIKE_POST };
}

export function likePostSuccess(post: Post) {
	return { type: LIKE_POST_SUCCESS, post };
}

export function likePostFailure(error: string) {
	return { type: LIKE_POST_FAILURE, error };
}

export function likingSubpost() {
	return { type: LIKE_SUBPOST };
}

export function likeSubpostSuccess(subpost: Subpost) {
	return { type: LIKE_SUBPOST_SUCCESS, subpost };
}

export function likeSubpostFailure(error: string) {
	return { type: LIKE_SUBPOST_FAILURE, error };
}

export function addTeamMembers() {
	return { type: ADD_TEAM_MEMBERS };
}

export function addTeamMembersSuccess() {
	return { type: ADD_TEAM_MEMBERS_SUCCESS };
}

export function addTeamMembersFailure(error: string) {
	return { type: ADD_TEAM_MEMBERS_FAILURE, error };
}

export function resetAddTeamMembersCompleteValue() {
	return { type: RESET_ADD_TEAM_MEMBERS_COMPLETE };
}

export function editTeam() {
	return { type: EDIT_TEAM };
}

export function editTeamSuccess(userTeams: UserTeams) {
	return { type: EDIT_TEAM_SUCCESS, userTeams };
}

export function editTeamFailure(error: string) {
	return { type: EDIT_TEAM_FAILURE, error };
}

export function deleteTeam() {
	return { type: DELETE_TEAM };
}

export function deleteTeamSuccess(teamId: string) {
	return { type: DELETE_TEAM_SUCCESS, teamId };
}

export function deleteTeamFailure(error: string) {
	return { type: DELETE_TEAM_FAILURE, error };
}

export function resetDeleteTeamSuccess() {
	return { type: RESET_DELETE_TEAM_SUCCESS };
}

export function resetCreateTeamSuccess() {
	return { type: RESET_CREATE_TEAM_SUCCESS };
}

export function resetEditTeamSuccess() {
	return { type: RESET_EDIT_TEAM_SUCCESS };
}

export function startSeason() {
	return { type: START_SEASON };
}

export function startSeasonSuccess(season: EditSeason) {
	return { type: START_SEASON_SUCCESS, season };
}

export function startSeasonFailure(error: string) {
	return { type: START_SEASON_FAILURE, error };
}

export function resetStartSeasonSuccess() {
	return { type: RESET_START_SEASON_SUCCESS };
}

export function endSeason(season: EditSeason) {
	return { type: END_SEASON, season };
}

export function endSeasonSuccess(teamId: string) {
	return { type: END_SEASON_SUCCESS, teamId };
}

export function endSeasonFailure(error: string) {
	return { type: END_SEASON_FAILURE, error };
}

export function resetEndSeasonSuccess() {
	return { type: RESET_END_SEASON_SUCCESS };
}

export function updateSeason() {
	return { type: UPDATE_SEASON };
}

export function updateSeasonSuccess(season: EditSeason) {
	return { type: UPDATE_SEASON_SUCCESS, season };
}

export function updateSeasonFailure(error: string) {
	return { type: UPDATE_SEASON_FAILURE, error };
}

export function resetUpdateSeasonSuccess() {
	return { type: RESET_UPDATE_SEASON_SUCCESS };
}

export function deletePost() {
	return { type: DELETING_POST };
}

export function deleteSubpost() {
	return { type: DELETING_SUBPOST };
}

export function deletePostFailure(error: string) {
	return { type: DELETE_POST_FAILURE, error };
}

export function deleteSubpostFailure(error: string) {
	return { type: DELETE_SUBPOST_FAILURE, error };
}

export function deletePostSuccess(deletedPost: Post, originalPost: Post) {
	return { type: DELETE_POST_SUCCESS, deletedPost, originalPost };
}

export function deleteSubpostSuccess(deletedSubpost: Subpost, originalSubpost: Subpost) {
	return { type: DELETE_SUBPOST_SUCCESS, deletedSubpost, originalSubpost };
}

export function resetDeletePostSuccess() {
	return { type: RESET_DELETE_POST_SUCCESS };
}

export function resetDeleteSubpostSuccess() {
	return { type: RESET_DELETE_SUBPOST_SUCCESS };
}

export function teamUserStatsLoading(teamId: string, userId: string) {
	return { type: TEAM_USER_STATS_LOADING };
}

export function teamUserStatsSuccess(stats: TeamStats) {
	return { type: TEAM_USER_STATS_SUCCESS, stats };
}

export function teamUserStatsFailure(error: string) {
	return { type: TEAM_USER_STATS_FAILURE, error };
}

export function sendingShoutout() {
	return { type: SENDING_SHOUT_OUT };
}

export function sendingShoutoutSuccess(posts: Post[], selectedTeamId: string | null) {
	return { type: SENDING_SHOUT_OUT_SUCCESS, posts, selectedTeamId };
}

export function sendingShoutoutFailure(error: string) {
	return { type: SENDING_SHOUT_OUT_FAILURE, error };
}

export function resetSendingShoutoutSuccess() {
	return { type: RESET_SENDING_SHOUT_OUT_SUCCESS };
}
